<div class="eiq-custom-tooltip" (mouseover)="showToolTip$.set(true)" (mouseleave)="showToolTip$.set(false)" cdkOverlayOrigin>
  <fa-icon [icon]="icon$()"></fa-icon>

  <div class="overlay" #trigger></div>

  @if (showToolTip$()) {
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="showToolTip$()"
      (overlayOutsideClick)="showToolTip$.set(false)"
      (detach)="showToolTip$.set(false)"
    >
      <div [@overlayAnimation]>
        <ng-content select="[slot=overlay]"></ng-content>
      </div>
    </ng-template>
  }
</div>
